import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
// import { TreeModule } from 'primeng';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppId, SAPID } from 'src/app/_shared/common/global-variables';
import { QuickDeligationService } from 'src/app/_services/ApplicationServices/quick-delegation.service';
import { addAdvanceRequest, advanceChkWF, advanceDate, advanceDelegatee, advanceRemarks, status, listAddRole, listAddSubRole, QuickDeligation, recentDelegatee, setSubRole, OnBehalfEmployee } from 'src/app/_services/ApplicationServices/quick-delegation';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { DatePipe } from '@angular/common';
import { catchError } from 'rxjs/operators';
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { FileValidationService } from 'src/app/_services/CommonServices/file-validation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidFileStatus } from 'src/app/_services/CommonServices/fileValidation'


@Component({
    selector: 'app-on-behalf-delegation',
    // standalone: true,
    // imports: [],
    templateUrl: './on-behalf-delegation.component.html',
    styleUrl: './on-behalf-delegation.component.css',
    providers: [MessageService],
    standalone: false
})
export class OnBehalfDelegationComponent implements OnInit {
  searchOnBehalfEmployee: string;
  finalOnBehalfEmp = [] = [''];
  onBehalfEmp: string[] = [''];
  onBehalfEmployee: recentDelegatee[] = [];
  errorMessage: string;
  Validationonbehalfemployee: boolean = false;
  NoOfSelectedApp: number;
  removeAppName: string;
  isCheckAllApp: boolean = false;
  SelectAllRoles: boolean = false;
  selectedApps: QuickDeligation[] = [];
  appRoleAndSubRoles: QuickDeligation[] = [];
  isSubmitbuttonshow = false;
  noData: boolean = true;
  currentPageUrl: boolean = false;
  recentDelegatee: recentDelegatee[] = [];
  searchText: string;
  delegateeSapId: string;
  ApplicationId: number = 0;
  cancelBtn: Boolean;
  submitBtn: Boolean;
  IsSubRoleApplication: boolean = false;
  listDelegatee: advanceDelegatee[] = new Array;
  listAddRole: listAddRole[] = new Array;
  uploadedDoc: any[] = [];
  arraybufferofFiile: ArrayBuffer;
  DocumentStreamData: ArrayBuffer
  fileData: ArrayBuffer;
  RCFile: boolean = false;
  fileType: String;
  fileNameDnld: String;
  createAdvanceDelegation: addAdvanceRequest[] = [];
  listAddSubRole: listAddSubRole[] = new Array;
  listchkWF: advanceChkWF[] = new Array;
  listRemarks: advanceRemarks[] = new Array;
  listDate: advanceDate[] = new Array;
  DelegationStartDate: string = null;
  DelegationEndDatetime: string = null;
  touchDate: Date = new Date();
  ActionBy: string = this.global.UserLoggedInSAPID;
  RequesterSAPId: string = this.global.UserLoggedInSAPID;
  advancedRemarks: string = "Due to non-availability in office";
  reqSubmitMessage: status[] = [];
  reqStatusRemarks: string = "";
  listSubRoleAsPerRoleSelection = [];
  listAddSubRoleAsperRoleSelection = [];
  public DelegatorChecked: boolean = false;
  Appselected: string = '';
  selectedSubRoles: setSubRole[] = [];
  newList: OnBehalfEmployee[] = [];
  minDate: Date;
  public myDatestring: string;
  myDate: Date;
  myDatestringthritydays: string;
  DateRange: string;
  filterRoleAndSubRole: any[] = [];
  appChoice: string;
  encValues: string = '';
  url: string;
  encSapId: string = '';
  encAppId: string = '';
  encDelReqID: string = '';
  copyreqStatusRemarks: string = "";
  brands: string[] = [''];
  filteredBrands: any[];
  brand: string[] = [''];
  hiddenBtn: boolean;
  NoOfSelectedRoleWithoutSubRole: number;
  CheckwithoutRole: boolean = false;
  SelectAllSubRoles: boolean = false;
  public AdvanceDateRangeFilter: Date[];
  isDelegateeToggle = false;
  ValidationRoles: boolean = false;
  DelegatorConsen: boolean;
  remarkchecked = false;
  Validationfileupload: boolean = false;
  ValidationSelectDelegetee: boolean = false;
  ValidationSubRoles: boolean = false;
  validRequest = true;
  listReqStatusRemarks: any;
  StreamData: ArrayBuffer;
  ValidationRadioBtn: boolean = false;
  FromDate: Date;
  ToDate: number;
  reqStatusRemarksMultiLine
  IsValidFile: ValidFileStatus;
  IsValidFileContent: ValidFileStatus;
  selectedFile: File | null = null;
  removedSubRoleslength: any[] = [];

  @ViewChild('validationTemp') templateRef: TemplateRef<any>;
  @ViewChild('alertTemp') templateRefsubmit: TemplateRef<any>;
  @ViewChild('validTemp') templateRefsubmit2: TemplateRef<any>;
  @ViewChild('validOnBehalf') templateOnBehalfsubmit: TemplateRef<any>;
  @ViewChild('alertOnBehalf') templateOnBehalfalert: TemplateRef<any>;
  @ViewChild('validDate') templateDate: TemplateRef<any>;
  @ViewChild('validSubRoleSelected') templateSubRole: TemplateRef<any>;
  @ViewChild('validDelegatee') templatevalidDelegatee: TemplateRef<any>;
  @ViewChild('validonBehalfEmp') templatevalidonBehalfEmp: TemplateRef<any>;
  @ViewChild('validationuploadFile') templatevalidationuploadFile: TemplateRef<any>;
  @ViewChild('alertSapid') templateSapidAlert: TemplateRef<any>;
  @ViewChild('alertInvalidSapid') templateInvalidSapid: TemplateRef<any>;
  @ViewChild('rejectModal') public rejectModal: ModalDirective;
  @ViewChild('approvedModal') templateapprovedModal: TemplateRef<any>;
  @ViewChild('alertSingleApp') templatealertSingleApp: TemplateRef<any>;
  @ViewChild('approvedModalMultiLine') approvedModalMultiLine: TemplateRef<any>;
 
  displayFailRequest: boolean;
  diswarmingOndehalfDele: boolean;



  ingredient!: string;
  sucImg = "assets/images/tick.gif";
  alertImg = "assets/images/alert.svg";
  // on keyup input close btn show
  searchTxt: string = '';
  closebtn: boolean = true;
  rangeDates: any;
  changeEvt(e) {
    if (this.searchTxt != null || this.searchTxt != "") {
      this.closebtn = false;
    }
  }
  clearInput() {
    this.searchTxt = "";
    this.closebtn = true;
  }
  // on keyup input close btn show End

  // Class Active & Inactive Toggled
  delegateToggled = false;
  delegateHideDiv = false;
  public toggleDelegate() {
    this.delegateToggled = !this.delegateToggled;
    this.delegateHideDiv = !this.delegateHideDiv;
  }

  durationToggled = false;
  durationHideDiv = false;
  public toggleDuration() {
    this.durationToggled = !this.durationToggled;
    this.durationHideDiv = !this.durationHideDiv;
  }

  remarksToggled = false;
  remarksHideDiv = false;
  public toggleRemarks() {
    this.remarksToggled = !this.remarksToggled;
    this.remarksHideDiv = !this.remarksHideDiv;
  }
  // Class Active & Inactive Toggled End


  //range Calendar
  ranges: any = [{
    value: [new Date(new Date().setDate(new Date().getDate() + 30)), new Date()],
    label: '1 Month'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 91))],
    label: '3 Months'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 182))],
    label: '6 Months'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 365))],
    label: '1 Year'
  }
  ];

  // Show and Hide Div
  billing: boolean = true;
  selectbilling: boolean = false;
  addSpocD() {
    this.billing = false;
    this.selectbilling = true;
  }

  addSpocD1() {
    this.billing = true;
    this.selectbilling = false;
  }

  // Show and Hide Div
  addApps: boolean = false;
  selectApp: boolean = true;
  addSpoc() {
    this.addApps = true;
    this.selectApp = false;
  }

  addSpocB() {
    this.addApps = false;
    this.selectApp = true;
  }



  addApps1: boolean = false;
  selectApp1: boolean = true;
  addSpoc1() {
    this.addApps1 = true;
    this.selectApp1 = false;
  }

  addSpocA() {
    this.addApps1 = false;
    this.selectApp1 = true;
  }
  // Show and Hide Div End

  //  Select all CheckBox
  mast = false;
  child1 = false
  child2 = false
  child3 = false
  child4 = false
  child5 = false
  child6 = false
  child7 = false
  master() {
    this.mast = this.mast;

    if (this.mast === true) {
      this.child1 = true
      this.child2 = true
      this.child3 = true
      this.child4 = true
      this.child5 = true
      this.child6 = true
      this.child7 = true
    }
    if (this.mast === false) {
      this.child1 = false
      this.child2 = false
      this.child3 = false
      this.child4 = false
      this.child5 = false
      this.child6 = false
      this.child7 = false
    }
  }
  child() {
    if (this.child1 === true && this.child2 === true && this.child3 === true && this.child4 === true
      && this.child5 === true && this.child6 === true && this.child7 === true) {
      this.mast = true;
    }
    else {
      this.mast = false;
    }
  }

  // Roles (without Sub-Roles)  Select all CheckBox
  mastR = false;
  role1 = false
  role2 = false
  role3 = false
  masterR() {
    this.mastR = this.mastR;
    if (this.mastR === true) {
      this.role1 = true
      this.role2 = true
      this.role3 = true
    }
    if (this.mastR === false) {
      this.role1 = false
      this.role2 = false
      this.role3 = false
    }
  }
  childR() {
    if (this.role1 === true && this.role2 === true && this.role3 === true) {
      this.mastR = true;
    }
    else {
      this.mastR = false;
    }
  }

  // Roles (along with Sub-Roles) Select all CheckBox
  mastR1 = false;
  lob1 = false
  lob2 = false
  masterR1() {
    this.mastR1 = this.mastR1;
    if (this.mastR1 === true) {
      this.lob1 = true
      this.lob2 = true
    }
    if (this.mastR1 === false) {
      this.lob1 = false
      this.lob2 = false
    }
  }
  childR1() {
    if (this.lob1 === true && this.lob2 === true) {
      this.mastR1 = true;
    }
    else {
      this.mastR1 = false;
    }
  }
  // BU Head Select all CheckBox
  mastR2 = false;
  bu1 = false
  masterR2() {
    this.mastR2 = this.mastR2;
    if (this.mastR2 === true) {
      this.bu1 = true
    }
    if (this.mastR2 === false) {
      this.bu1 = false
    }
  }
  childR2() {
    if (this.bu1 === true) {
      this.mastR2 = true;
    }
    else {
      this.mastR2 = false;
    }
  }

  // Expand and Collapse All
  index: number = null;
  //lastIndex = -2;
  txtTgl: boolean = true;
  openAll() {
    this.index = (this.index === 1) ? 0 : this.index + 1;
  }
  // Expand and Collapse All End


  // Success Alert Start
  // showSuccess() {
  //   this.messageService.add({ severity: 'success', });
  //   setTimeout(() => {
  //     this.router.navigate(['/advanceDeligation']);
  //   }, 100);
  // }
  // Success Alert End


  /* MODAL */
  modalRef: BsModalRef;
  // Alert 
  alertIcon = "assets/images/alert-01.svg";
  errorIcon = "assets/images/alert.svg";
  alert(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'alertM' })
    );
  }
  errorOnbehalfDelegation: string = '';
  visible: any;
  visibleFile: any;
  messagetoast: string;
  constructor(private global: GlobalService, private loginService: LoginService, private datePipe: DatePipe, private appInsights: AppInsightsService,
    private modalService: BsModalService, private messageService: MessageService, private router: Router,
    private advancedDelService: QuickDeligationService, private fileValidateService: FileValidationService, private SpinnerService: NgxSpinnerService) {
    this.FromDate = new Date();
    this.ToDate = this.FromDate.setMonth(this.FromDate.getMonth() + 1);
    this.rangeDates = [new Date, new Date(this.ToDate)];


    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
    this.myDate = new Date();
    this.myDatestring = this.datePipe.transform(this.myDate, 'dd-MMM-yyyy');
    let thirtyday = (d => new Date(d.setDate(d.getDate() + 30)))(new Date);
    this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd-MMM-yyyy');

    var date1 = new Date(this.myDatestring);
    var date2 = new Date(this.myDatestringthritydays);

    this.DelegationStartDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
    this.DelegationEndDatetime = this.datePipe.transform(date2, 'yyyy-MM-dd');
  }

  ngOnInit(): void {
    this.SpinnerService.show();
    //var onBehalfFlag = localStorage.getItem('Onbehalf');
    var onBehalfFlag = this.global.getOnBehalf;
    if (this.router.url.includes('onBehalfDelegation')) {
      this.currentPageUrl = true;
    }
    else {
      this.currentPageUrl = false;
    }
    this.appInsights.logPageView('Onbehalf Delegation', '/OnBehalfDelegation');

    if (this.global.UserLoggedInSAPID === undefined || this.global.UserLoggedInSAPID === null) {
      this.myFirstOperation();
    } else {
      this.getExceptioanlAllAppRoleAndSubRole();
      this.getRecentDelegatee();
    }
  }

  myFirstOperation() {
    const result = this.loginService.GetDecryptCodeValue(this.global.getSapId());
    result.subscribe((result) => {
      this.global.UserLoggedInSAPID = result.cipherText;
      this.RequesterSAPId = this.global.UserLoggedInSAPID;
      this.ActionBy = this.global.UserLoggedInSAPID;
      this.getExceptioanlAllAppRoleAndSubRole();
      this.getRecentDelegatee();
    });
  }

  getRecentDelegatee() {
    this.advancedDelService.fetchRecentDelegatee().subscribe(
      {
        next: data => {
          this.recentDelegatee = data;
          // this.brands[0] = this.recentDelegatee[0].EmpName + ' (' + this.recentDelegatee[0].SAPID + ')';
          // this.brand[0] = this.recentDelegatee[0].EmpName + ' (' + this.recentDelegatee[0].SAPID + ')';
          // this.searchText = this.brands[0];
          // this.delegateeSapId = this.recentDelegatee[0].SAPID;
          this.SpinnerService.hide();
        },
        error: err => this.errorMessage = err
      }
    )
  }

  getExceptioanlAllAppRoleAndSubRole() {
    this.advancedDelService.fetchExceptioanlAccessApplications().subscribe(
      {
        next: appRoles => {
          this.appRoleAndSubRoles = appRoles;
          this.SpinnerService.hide();
        },
        error: err => this.errorMessage = err
      }
    )
  }

  filterBrands(event): void {
    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      let brand = this.brands[i];
      if (brand.toString().toLowerCase().indexOf(event.query.toString().toLowerCase()) !== -1) {
        this.filteredBrands.push(brand);
      }
    }
  }

  FetchEmployeeSuggestion(event) {
    if (this.searchOnBehalfEmployee.length > 4) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.searchOnBehalfEmployee
        }
      this.advancedDelService.fetchDelegateeSuggestions(sapId).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;
          },
          error: err => this.errorMessage = err
        });
      this.SelectedBrands();
    }
  }

  updateDelegateeId(event) {
    if (event !== "" && this.searchOnBehalfEmployee !== "") {
      this.delegateeSapId = event.toString().substring(event.toString().length - 9, event.toString().length - 1);
    }
    else {
      this.delegateeSapId = "";
    }
  }

  SelectedBrands() {
    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      let brand = this.brands[i];

      this.filteredBrands.push(brand);

    }
  }

  bindRecentDelegatee() {
    this.brands = [];
    for (let i = 0; i < this.recentDelegatee.length; i++) {
      this.brands[i] = this.recentDelegatee[i].EmpName + ' (' + this.recentDelegatee[i].SAPID + ')';
    }
  }

  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  openModal(approvedModal: TemplateRef<void>) {
    this.modalRef = this.modalService.show(approvedModal, this.config);
    document.body.classList.add('modal-open2');
  }

  hideSuccessMsg() {
    document.body.classList.remove('modal-open2');
  }

  pullOnBehalfEmployee() {
    if (this.searchOnBehalfEmployee.length > 5) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.searchOnBehalfEmployee,
        }
      this.advancedDelService.fetchDelegateeSuggestions(sapId).subscribe(
        {
          next: data => {
            this.onBehalfEmployee = data;
            if (this.onBehalfEmployee.length < 1) {
              this.alert(this.templateInvalidSapid);
            }
          },
          error: err => this.errorMessage = err
        });
      if (this.onBehalfEmployee.length > 0) {
        for (let i = 0; i < this.onBehalfEmployee.length; i++) {
          this.onBehalfEmp[i] = this.onBehalfEmployee[i].EmpName + '(' + this.onBehalfEmployee[i].SAPID + ')';
        }
      }
    }
    else {
      this.Validationonbehalfemployee = true;
    }
  }

  bindOnBehalfEmployee() {
    this.finalOnBehalfEmp = [''];
    this.pullOnBehalfEmployee();
    for (let i = 0; i < this.onBehalfEmp.length; i++) {
      if (this.finalOnBehalfEmp.length > 0) {
        this.Validationonbehalfemployee = false;
      }
      this.Validationonbehalfemployee = true;
      if (this.onBehalfEmployee.length > 0) {
        this.finalOnBehalfEmp.push(this.onBehalfEmp[i]);
        this.Validationonbehalfemployee = false;
      } else {
        this.Validationonbehalfemployee = true;
      }
    }
  }

  RemoveSelectedApp(event) {
    this.removeAppName = event.target.innerHTML;
    for (let i = 0; i < this.selectedApps.length; i++) {
      if (this.selectedApps[i].AppName == this.removeAppName) {
        this.appRoleAndSubRoles.push(this.selectedApps[i]);
        this.selectedApps.splice(i, 1);
        this.NoOfSelectedApp = this.selectedApps.length;
        this.isCheckAllApp = false;
        if (this.selectedApps.length > 0) {
          this.noData = false;
          this.addApps = true;
        } else {
          this.noData = true;
          this.addApps = false;
          this.isSubmitbuttonshow = false;
        }
      }
    }
  }

  CheckAllApplication(event) {
    if (event.target.checked) {
      for (let i = 0; i < this.appRoleAndSubRoles.length; i++) {
        this.selectedApps.push(this.appRoleAndSubRoles[i]);
        this.NoOfSelectedApp = this.selectedApps.length;
        this.noData = false;
        this.addApps = true;
      }
      this.appRoleAndSubRoles = [];
    } else {
      for (let i = 0; i < this.selectedApps.length; i++) {
        this.appRoleAndSubRoles.push(this.selectedApps[i]);
      }
      this.selectedApps = [];
      this.NoOfSelectedApp = this.selectedApps.length;
      this.noData = true;
      this.addApps = false;
    }
  }

  onSelectApp(appName: string, appid: number, e) {
    if (e.target.checked) {
      this.SpinnerService.show();
      this.ApplicationId = appid;
      // this.listDelegatee = [];
      // this.listAddRole = [];
      // this.uploadedDoc = [];
      // this.createAdvanceDelegation = [];
      // this.selectedApps = [];
      this.DelegatorChecked = false;
      if (this.searchOnBehalfEmployee == null || this.searchOnBehalfEmployee == undefined) {
        //this.alert(this.templateSapidAlert);
        this.appRoleAndSubRoles.find(x => x.AppId == appid)["checkapp"] = false;
        this.SpinnerService.hide();
        this.messagetoast = "Please Enter Onbehalf Employee SAP ID";
        this.visible = true;
      } else {
        const Appid = <AppId>
          {
            ReqAppid: this.ApplicationId,
            ReqSAPID: this.searchOnBehalfEmployee.substring(this.searchOnBehalfEmployee.length - 9, this.searchOnBehalfEmployee.length - 1)
          }
        this.advancedDelService.fetchAppOnBehalfDelegation(Appid).subscribe({
          next: data => {
            if (data.length == 0) {
              //this.alert(this.templateOnBehalfalert);
              this.messagetoast = "Don't have access to delegate.";
              this.visible = true;
              this.appRoleAndSubRoles.find(x => x.AppId == appid)["checkapp"] = false;
              this.SpinnerService.hide();
            }
            else if (data.length == 1) {

              if (this.selectedApps.length == 1) {
                //this.alert(this.templatealertSingleApp);
                this.messagetoast = "Allow Single App.";
                this.visible = true;
                this.SpinnerService.hide();
                return;
              }

              this.SpinnerService.hide();
              this.appRoleAndSubRoles.find(x => x.AppId == appid)["checkapp"] = true;
              let indx = this.appRoleAndSubRoles.findIndex(x => x.AppId == appid);
              this.appRoleAndSubRoles.splice(indx, 1);
              this.cancelBtn = true;
              this.submitBtn = true;
              this.Appselected = appName;
              for (let i = 0; i < data.length; i++) {
                if (data[i].AppName == appName) {
                  for (let h = 0; h < data[i].CDS_GetRoleAndSubRole.length; h++) {
                    this.selectedSubRoles.push(data[i].CDS_GetRoleAndSubRole[h]);
                    if (data[i].AppName == 'AAM') {
                      this.IsSubRoleApplication = true;
                    }
                    else {
                      this.IsSubRoleApplication = false;
                    }
                  }
                  if (this.selectedApps.length == 0) {
                    this.selectedApps.push(data[i]);
                  }
                  else if (this.selectedApps.length > 0) {
                    this.selectedApps[0] = data[i];
                    this.appRoleAndSubRoles.slice(i, 1);
                  }
                  this.NoOfSelectedApp = this.selectedApps.length;
                }
              }
            }
          },
          error: err => this.errorMessage = err
        });
      }
    } else {
      if (this.selectedApps.length > 0)
        this.appRoleAndSubRoles.push(this.selectedApps[0]);
    }
  }

  OnKeyUpDelegative(event, appId) {
    this.searchText = event.target.value;
    if (this.searchText.length > 3) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.searchText
        }
      this.advancedDelService.fetchDelegateeSuggestions(sapId).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;

          },
          error: err => this.errorMessage = err
        });
    }

    if (this.searchText == "") {
      for (var i = this.listDelegatee.length; i--;) {
        if (this.listDelegatee[i].appId === appId) { this.listDelegatee.splice(i, 1); }
      }
    }
  }

  updateAdvanceDelegatee(event, appId) {
    this.delegateeSapId = this.searchText.toString().substring(this.searchText.toString().length - 9, this.searchText.toString().length - 1);

    for (var i = this.listDelegatee.length; i--;) {
      if (this.listDelegatee[i].appId === appId) { this.listDelegatee.splice(i, 1); }
    }
    this.ValidationSelectDelegetee = false;
    this.listDelegatee.push({ appId: appId, delegateeId: this.delegateeSapId });

  }

  onDatesRangeFilterSelected() {
    let thirtyday = (d => new Date(d.setDate(d.getDate() + 30)))(new Date);
    if (this.ingredient == "1-Month") {
      thirtyday = (d => new Date(d.setDate(d.getDate() + 30)))(new Date);
      this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd/MMM/yyyy');

    } else if (this.ingredient == "3-Month") {
      thirtyday = (d => new Date(d.setDate(d.getDate() + 90)))(new Date);
      this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd/MMM/yyyy');
      this.myDatestring = this.datePipe.transform(this.myDate, 'dd/MMM/yyyy');
      let date1 = new Date(thirtyday);
      let date2 = new Date(this.myDatestringthritydays);
      this.DelegationStartDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
      this.DelegationEndDatetime = this.datePipe.transform(date2, 'yyyy-MM-dd');
    } else if (this.ingredient == "1-Year") {
      thirtyday = (d => new Date(d.setDate(d.getDate() + 365)))(new Date);
      this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd/MMM/yyyy');
      let date1 = new Date(thirtyday);
      let date2 = new Date(this.myDatestringthritydays);
      this.DelegationStartDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
      this.DelegationEndDatetime = this.datePipe.transform(date2, 'yyyy-MM-dd');
    }
    this.AdvanceDateRangeFilter = [new Date, thirtyday];
  }

  onAdvanceRemarks(event, appId) {

    if (event != "" && event != " ") {
      this.listRemarks.push({ remarksText: event, appId: appId });
    }
    else {
      for (var i = this.listRemarks.length; i--;) {
        if (this.listRemarks[i].appId === appId) {
          this.listRemarks.splice(i, 1);
        }
      }
    }


  }

  showSuccess(code: number) {

    if (code === 0) {

      this.messageService.add({ severity: "success" });
      setTimeout(() => {
        this.router.navigate(['/approval']);
      }, 150000);
    }
    else {
      this.messageService.add({ severity: "error" });
      setTimeout(() => {
        this.router.navigate(['/approval']);
      }, 150000);
    }
  }

  OnBehalfSubmit() {
    this.SpinnerService.show();
    if ((this.listDelegatee.length == this.selectedApps.length || this.isDelegateeToggle == true)) {
      //this.onSubmit();
      this.reqSubmitMessage = [];
      this.advancedDelService.addOnBehalfDelegationRequest(this.createAdvanceDelegation).subscribe((res) => {

        this.copyreqStatusRemarks = '';
        this.reqStatusRemarks = '';
        if (res === null || res === '') {
          this.SpinnerService.hide();
          this.displayFailRequest = true;
        }
        else {
          this.SpinnerService.hide();
          this.reqSubmitMessage.push(res);
          //this.reqStatusRemarks = res.StatusRemarks;
          let delegation = res.StatusRemarks.substring(0, res.StatusRemarks.length - 1);
          this.reqStatusRemarksMultiLine = delegation.split(',');
          //this.openModal(this.templateapprovedModal);
          this.loginService.pullEncryptValue(this.global.UserLoggedInSAPID).subscribe(res => {
            if (res.clearText != "" && this.reqSubmitMessage[0].StatusCode != 2) {
              this.loginService.isEncrypted = true;
              this.encValues = res.clearText;
              this.encAppId = "/CmHtkGSJ91DqNC1Wxq0Hg=="; //42  DelReqid
              this.encDelReqID = (this.reqSubmitMessage[0].EncDelReqid === null || this.reqSubmitMessage[0].EncDelReqid === "") ? this.encValues : this.reqSubmitMessage[0].EncDelReqid;
              //this.url = "https://qa1.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encValues  +"&&ApplicationID="+this.encAppId+"&&EmployeeID="+this.encValues,"pop", "status=no,height=200,width=600,resizable=no,left=400,top=100,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false";
             // window.open("https://wf33.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encDelReqID + "&&ApplicationID=" + this.encAppId + "&&EmployeeID=" + this.encValues, "pop", "status=no,height=200,width=400,resizable=no,left=400,top=600,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false").focus();
            }
          }
          )
          this.alert(this.approvedModalMultiLine);
          setTimeout(() => {
            this.removeModal();
            this.router.navigate(['/approval']);
          }, 1000);
        }
      },
        (error: Response) => {
          this.displayFailRequest = true;
        }
      );
    }
    else {
      this.SpinnerService.hide();
      this.ValidationRoles = this.listAddRole.length == 0 ? true : false;
      this.ValidationSelectDelegetee = true;
    }
  }

  onSubmit() {
    this.createAdvanceDelegation = [];
    if ((this.listDelegatee.length == this.selectedApps.length || this.isDelegateeToggle == true)) {
      this.ValidationRoles = this.listAddRole.length == 0 ? true : false;
      if ((this.isDelegateeToggle == true) && this.listDelegatee.length == 0) {
        this.ValidationRoles = false;
      }
      if (this.DelegatorChecked == false) {
        this.visible = true;
        this.messagetoast = "Provide Delegator Consent.";
        return;
      }
      if (this.DelegationStartDate !== "" || this.DelegationStartDate !== undefined) {
        for (let i = 0; i < this.listAddRole.length; i++) {
          const addAdvanceRequest = <addAdvanceRequest>
            {
              AppId: this.listAddRole[i].AppId,
              RoleId: this.listAddRole[i].RoleId,
              RequesterSAPId: this.RequesterSAPId,
              DelegateeSAPId: this.listDelegatee.length > 1 ? this.listDelegatee.find(del => del.appId === this.listAddRole[i].AppId).delegateeId.toString() : this.listDelegatee[0].delegateeId.toString(),
              DelegationEndDatetime: this.DelegationEndDatetime,
              DelegationStartDate: this.DelegationStartDate,
              ActionBy: this.ActionBy,
              touchDate: this.touchDate,
              RequestStatus: "PRM",
              ValidationErrorMsg: 'Y',
              SubRole: [
                {
                  AppId: this.listAddRole[i].AppId,
                  RollId: this.listAddRole[i].RoleId,
                  Subrolid: 0,
                  SubRoleName: null,
                }
              ],
              DelegatorConsen: this.DelegatorChecked
            }
          this.createAdvanceDelegation.push(addAdvanceRequest);

        }


        for (let i = 0; i < this.createAdvanceDelegation.length; i++) {
          this.createAdvanceDelegation[i].SubRole.splice(0, 1);
          if (this.remarkchecked) {
            this.createAdvanceDelegation[i].Remarks = this.advancedRemarks;
          }
          if (this.listchkWF.length >= i && this.listchkWF[i] != undefined) {
            this.createAdvanceDelegation[i].IsWFBypass = this.listchkWF.find(WF => WF.appId === this.listAddRole[i].AppId).chkWF;
          }
          else {
            this.createAdvanceDelegation[i].IsWFBypass = false;
          }
          if (this.listRemarks.length >= i && this.listRemarks[i] != undefined) {
            this.createAdvanceDelegation[i].Remarks = this.listRemarks.find(remarks => remarks.appId === this.listAddRole[i].AppId).remarksText;
          }
          else {
            this.createAdvanceDelegation[i].Remarks = null;
          }

          //condition for On-Behalf Employee 
          if (this.currentPageUrl) {
            if (this.searchOnBehalfEmployee == "" || this.searchOnBehalfEmployee == undefined || this.searchOnBehalfEmployee.length < 8) {
              this.Validationonbehalfemployee = true;
              return;
            }
            this.Validationonbehalfemployee = false;
            this.createAdvanceDelegation[i].RequesterSAPId = this.searchOnBehalfEmployee.substring(this.searchOnBehalfEmployee.length - 9, this.searchOnBehalfEmployee.length - 1);
            if (this.uploadedDoc.length == 0) {
              this.Validationfileupload = true;
              this.visible = true;
              this.messagetoast = "Please Upload the Document";
              return;
            }
            this.Validationfileupload = false;
            this.createAdvanceDelegation[i].DocumentList = this.uploadedDoc;
          }
          for (let k = 0; k < this.listSubRoleAsPerRoleSelection.length; k++) {
            if (this.createAdvanceDelegation[i].AppId === this.listSubRoleAsPerRoleSelection[k]["AppId"] && this.createAdvanceDelegation[k].RoleId === this.listSubRoleAsPerRoleSelection[k]["AppRoleID"] && this.listSubRoleAsPerRoleSelection[k].SubRoleName.length > 0) {
              if (this.listAddSubRole.length == 0) {
                this.validRequest = false;
                this.ValidationSubRoles = true;
                return;
              }
              else {
                if (this.listAddSubRole.find(a => a.RollId === this.listSubRoleAsPerRoleSelection[k]["AppRoleID"]) === undefined) {
                  this.validRequest = false;
                  this.ValidationSubRoles = false;
                  return;
                }
                if (this.listAddSubRole.find(a => a.RollId === this.listSubRoleAsPerRoleSelection[k]["AppRoleID"]).RollId !== this.createAdvanceDelegation[k].RoleId) {
                  this.validRequest = false;
                  this.ValidationSubRoles = true;
                  return;
                }
              }
            }
          }
          for (let j = 0; j < this.listAddSubRole.length; j++) {
            if (this.createAdvanceDelegation[i].AppId === this.listAddSubRole[j].AppId && this.createAdvanceDelegation[i].RoleId === this.listAddSubRole[j].RollId) {
              this.createAdvanceDelegation[i].SubRole.push(this.listAddSubRole[j]);
            }
          }

        }

        if (this.createAdvanceDelegation.length > 0)
          this.rejectModal.show();
      }
      else {
        this.validRequest = false;
        this.alert(this.templateDate);
      }
    }
    else {
      this.ValidationRoles = this.listAddRole.length == 0 ? true : false;
      this.visible = true;
      this.messagetoast = "Please Enter Onbehalf Employee SAP ID";
    }
  }

  SelectAllRole(e) {
    if (e.target.checked) {
      this.selectedApps.forEach(element => {
        for (let i = 0; i < element.CDS_GetRoleAndSubRole.length; i++) {
          this.listAddRole.push({ AppId: element.CDS_GetRoleAndSubRole[i].AppId, RoleId: element.CDS_GetRoleAndSubRole[i].AppRoleID });
          element.CDS_GetRoleAndSubRole[i]["checkapp"] = true;
          this.isSubmitbuttonshow = true;
        }
      });
      this.NoOfSelectedRoleWithoutSubRole = this.listAddRole.length;
    } else {
      this.selectedApps.forEach(element => {
        for (let i = 0; i < element.CDS_GetRoleAndSubRole.length; i++) {
          element.CDS_GetRoleAndSubRole[i]["checkapp"] = false;
        }
      });
      this.listAddRole = [];
      this.NoOfSelectedRoleWithoutSubRole = this.listAddRole.length;
      this.isSubmitbuttonshow = false;
    }
  }

  addRoleEvent(appId, AppRoleId) {
    this.listSubRoleAsPerRoleSelection = [];
    if (this.listAddRole.find(a => a.RoleId === AppRoleId) === undefined) {
      this.listAddRole.push({ AppId: appId, RoleId: AppRoleId });
      this.isSubmitbuttonshow = true;
    }
    else {
      let indx = this.listAddRole.findIndex(a => a.RoleId === AppRoleId);
      this.listAddRole.splice(indx, 1);
    }
    for (let i = 0; i < this.selectedSubRoles.length; i++) {
      if (this.selectedSubRoles[i]["AppRoleID"] == AppRoleId && this.selectedSubRoles[i]["AppId"] == appId) {
        if (this.listSubRoleAsPerRoleSelection.find(a => a.RoleId === AppRoleId) === undefined) {
          this.listSubRoleAsPerRoleSelection.push({ AppId: appId, RoleId: AppRoleId });
          this.NoOfSelectedRoleWithoutSubRole = this.listAddRole.length;
          if (this.selectedSubRoles.length == this.listAddRole.length)
            this.SelectAllRoles = true;
          else
            this.SelectAllRoles = false;
        }
        else {
          let indx = this.listSubRoleAsPerRoleSelection.findIndex(a => a.RoleId === AppRoleId);
          this.listSubRoleAsPerRoleSelection.splice(indx, 1);
          this.NoOfSelectedRoleWithoutSubRole = this.listAddRole.length;
        }
      }
    }

    this.isSubmitbuttonshow = this.listAddRole.length == 0 ? false : true;//!this.ValidationRoles?false:true;
  }

  //Select all sub roles with appliaction

  SelectAllWithSubRole(e, appId, AppRoleId) {

    if (this.listAddRole.find(a => a.RoleId === AppRoleId) === undefined) {
      this.listAddRole.push({ AppId: appId, RoleId: AppRoleId });
    }
    else {
      let indx = this.listAddRole.findIndex(a => a.RoleId === AppRoleId);
      this.listAddRole.splice(indx, 1);
    }
    if (e.target.checked) {
      this.isSubmitbuttonshow = true;
      for (let i = 0; i < this.selectedSubRoles.length; i++) {
        if (this.selectedSubRoles[i]["AppRoleID"] == AppRoleId && this.selectedSubRoles[i]["AppId"] == appId) {
          if (this.listSubRoleAsPerRoleSelection.find(a => a.RoleId === AppRoleId) === undefined) {
            this.listSubRoleAsPerRoleSelection.push({ AppId: appId, RoleId: AppRoleId });
            this.selectedSubRoles[i].SubRoleName.forEach(x => {
              x["checkapp"] = true;
              this.listAddSubRole.push({ AppId: x.AppId, RollId: x.RollId, Subrolid: x.Subrolid, SubRoleName: x.SubRoleName, SubRoleCode: x.SubRoleCode  });
            });
          }
        }
      }
      this.selectedApps.forEach(element => {
        if (element.AppId == appId) {
          element["NoOfSelectedRoleWithoutSubRole"] = this.listAddSubRole.length;
        }
      });
    }
    else {
      this.selectedApps.forEach(element => {
        if (element.AppId == appId) {
          for (let i = 0; i < element.CDS_GetRoleAndSubRole.length; i++) {
            element.CDS_GetRoleAndSubRole[i]["checkapp"] = false;
            for (let i = 0; i < this.selectedSubRoles.length; i++) {
              if (element.CDS_GetRoleAndSubRole[i].AppRoleID == AppRoleId && element.CDS_GetRoleAndSubRole[i].AppId == appId) {
                if (this.listSubRoleAsPerRoleSelection.find(a => a.RoleId === AppRoleId) != undefined) {
                  let indx = this.listSubRoleAsPerRoleSelection.findIndex(a => a.AppId === appId && a.RoleId === AppRoleId);
                  this.listSubRoleAsPerRoleSelection.splice(indx, 1);
                  this.selectedSubRoles[i].SubRoleName.forEach(x => {
                    x["checkapp"] = false;
                    let ind = this.listAddSubRole.findIndex(a => a.Subrolid === x.Subrolid && a.RollId === AppRoleId);
                    this.listAddSubRole.splice(ind, 1);
                  });
                }
              }
            }
          }
          element["NoOfSelectedRoleWithoutSubRole"] = this.listAddSubRole.length;
        }
      });
    }
    this.ValidationRoles = this.listAddRole.length == 0 ? true : false;
  }
  // /old code Gopi/
  // SelectAllWithSubRole(appId, AppRoleId) {
  //   this.listSubRoleAsPerRoleSelection = [];
  //   if (this.listAddRole.find(a => a.RoleId === AppRoleId) === undefined) {
  //     this.listAddRole.push({ AppId: appId, RoleId: AppRoleId });
  //     this.isSubmitbuttonshow = true;
  //   }
  //   else {
  //     let indx = this.listAddRole.findIndex(a => a.RoleId === AppRoleId);
  //     this.listAddRole.splice(indx, 1);
  //   }
  //   for (let i = 0; i < this.selectedSubRoles.length; i++) {
  //     if (this.selectedSubRoles[i]["AppRoleID"] == AppRoleId && this.selectedSubRoles[i]["AppId"] == appId) {
  //       if (this.listSubRoleAsPerRoleSelection.find(a => a.RoleId === AppRoleId) === undefined) {
  //         this.listSubRoleAsPerRoleSelection.push({ AppId: appId, RoleId: AppRoleId });
  //         this.selectedSubRoles[i]["checkapp"] = true;
  //       }
  //       else {
  //         this.selectedSubRoles[i]["checkapp"] = false;
  //         let indx = this.listSubRoleAsPerRoleSelection.findIndex(a => a.RoleId === AppRoleId);
  //         this.listSubRoleAsPerRoleSelection.splice(indx, 1);
  //       }
  //     }
  //   }
  //   this.ValidationRoles = this.listAddRole.length == 0 ? true : false;
  // }

  // Invoke on Sub Role Selection
  addSubRoleEvent(appId, roleId, subRoleId, subRoleName, subRoleCode) {

    if (this.listAddRole.find(a => a.RoleId === roleId) === undefined) {
      this.listAddRole.push({ AppId: appId, RoleId: roleId });
    }

    if (this.listAddSubRole.find(a => a.Subrolid === subRoleId) === undefined) {
        this.listAddSubRole.push({ AppId: appId, RollId: roleId, Subrolid: subRoleId, SubRoleName: subRoleName, SubRoleCode : subRoleCode });
      if (this.listAddSubRole.length >= 2) {
        this.removedSubRoleslength.length = this.listAddSubRole.length - 1;// comparing with last listAddSubRole
        const subRoleExists = this.removedSubRoleslength.some(x => x.RollId === roleId &&
          ((subRoleId && x.Subrolid === subRoleId) || (subRoleCode && x.SubRoleCode === subRoleCode)));
        const roleExists = this.listAddRole.some(x => x.RoleId === roleId);

        if (!subRoleExists && !roleExists) {
          this.listAddRole.push({ AppId: appId, RoleId: roleId });
        }
      }
      else {
        this.listAddRole.push({ AppId: appId, RoleId: roleId });
      }
      this.isSubmitbuttonshow = true;
    }
    else {
      let indx = this.listAddSubRole.findIndex(a => a.Subrolid === subRoleId);
      this.listAddSubRole.splice(indx, 1);
    }

    if (this.listAddSubRole.length == 0) {
      let indx = this.listAddRole.findIndex(a => a.AppId == appId && a.RoleId == roleId);
      this.listAddRole.splice(indx, 1);
    }

    this.selectedApps.forEach(element => {
      if (element.AppId == appId) {
        element["NoOfSelectedRoleWithoutSubRole"] = this.listAddSubRole.filter(x => x.AppId == appId).length;
        if (this.listAddSubRole.filter(x => x.RollId == roleId).length == element.CDS_GetRoleAndSubRole.filter(x => x.AppRoleID == roleId)[0]['SubRoleName'].length) {
          element.CDS_GetRoleAndSubRole.filter(x => x.AppRoleID == roleId)[0]['SelectAllRoles'] = true;
        }
        else
          element.CDS_GetRoleAndSubRole.filter(x => x.AppRoleID == roleId)[0]['SelectAllRoles'] = false;
      }
    });
  }

  onAdvancechkWF(event, appId) {
    if (event != null && event == true) {
      this.listchkWF.push({ chkWF: event, appId: appId });
    }
    else {
      this.listchkWF.push({ chkWF: event, appId: appId });
      for (var i = this.listchkWF.length; i--;) {
        if (this.listchkWF[i].appId === appId) {
          this.listchkWF.splice(i, 1);
        }
      }
    }
  }

  onUploadDossier(event) {
    this.fileType = "ExceptionalFiles";
    this.uploadDocument(event, this.fileType);
  }

  uploadDocument(event, fileType) {
    this.errorOnbehalfDelegation = null;
    const input = event as HTMLInputElement;
    this.selectedFile = input.files[0];
    if (this.selectedFile) {
      this.IsValidFile = this.fileValidateService.ValidateFile(this.selectedFile);
      if (this.IsValidFile.IsValid) {
        const reader = new FileReader();
        reader.onload = () => {
          const content = reader.result as string;
          this.IsValidFileContent = this.fileValidateService.ValidateFileContent(content);
          if (this.IsValidFileContent.IsValid) {
            let fileReader = new FileReader();
            event.currentFiles.forEach(file => {
              fileReader.readAsDataURL(file);
              this.arraybufferofFiile = file.arrayBuffer();
              fileReader.onload = (reader: any) => {
                this.StreamData = reader.target.result.split(',')[1];
                let DocumentList: any = {
                  DocType: fileType.toString(),
                  DocName: file.name.toString(),
                  DocumentStreamData: this.StreamData
                };
                this.uploadedDoc.push(DocumentList);
              }
            });
          }          
          else {
            this.errorOnbehalfDelegation = this.IsValidFileContent.ErrorMessage;
            this.visibleFile = true;
          }
        };
        reader.readAsText(this.selectedFile);
        input.value = '';
      }
      else {
        this.errorOnbehalfDelegation = this.IsValidFile.ErrorMessage;
        this.visibleFile = true;
      }
    }
    else {
      this.errorOnbehalfDelegation = "Please select file";
      this.visibleFile = true;
    }
  }

  RemoveItem(event) {
    this.Validationfileupload = true;
    this.uploadedDoc = [];
  }

  public onDelegatorchecked(event) {
    this.DelegatorChecked = event;
    if (this.DelegatorChecked == true) {
      this.DelegatorConsen = false;
    }
    else {
      this.DelegatorConsen = true;
    }
  }

  moveDate() {
    this.DelegationStartDate = this.datePipe.transform(this.rangeDates[0], 'yyyy-MM-dd');
    this.DelegationEndDatetime = this.datePipe.transform(this.rangeDates[1], 'yyyy-MM-dd');
  }

  reloadWindow() {
    setTimeout(() => {
      this.router.navigate(['/approval']);
    }, 100);
  }

  removeModal() {
    this.modalService.hide(1);
    document.body.classList.add('modal-open2');
  }

  OnClick() {
    this.visible = false;
  }
}
